module.exports = __webpack_public_path__ + "static/img/xxlsg.3f1fab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xxlsg.png
// module id = llUO
// module chunks = 1